import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { SettingsService } from '../settings/settings.service';
import { MaterialModule } from '../material/material.module';
import { CommonModule } from '@angular/common';
import { ResultadoSimulacionComponent } from '../simulacion/resultado-simulacion/resultado-simulacion.component';
import { PdfSimulacionComponent } from '../simulacion/pdf-simulacion/pdf-simulacion.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IdInversorService } from '../simulacion/services/id-inversor.service';
import { InversionistaDataSimulacionService } from '../simulacion/services/inversionista-data-simulacion.service';
import { EventService } from '../simulacion/services/event.service';
import { SharedDataService } from '../simulacion/services/shared-data.service';
import { Router } from '@angular/router';
import { TablaInversionesComponent } from '../simulacion/tabla-inversiones/tabla-inversiones.component';

@Component({
  selector: 'app-simulacion-publica',
  standalone: true,
  imports: [
    MaterialModule,
    CommonModule,
    ResultadoSimulacionComponent,
    PdfSimulacionComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './simulacion-publica.component.html',
  styleUrl: './simulacion-publica.component.less',
})
export class SimulacionPublicaComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;

  formGroup: FormGroup;
  valForm!: FormGroup;
  enviandoBtn:boolean = false;
  showStepper: boolean = false;
  isPublicSimulation: boolean = true;

  step: Number = 1;
  subStep: Number = 1;
  

  constructor(
    private _formBuilder: FormBuilder,
    private settings: SettingsService,
    public snackBar: MatSnackBar,
    private idInversorService: IdInversorService,
    private inversionistaDataSimulacionService: InversionistaDataSimulacionService,
    private eventService: EventService,
    private sharedDataService: SharedDataService,
    private router: Router
  ) {
    this.formGroup = this._formBuilder.group({
      monto: [
        '',
        [Validators.required, this.validateMonto, this.validateMontoMinimo],
      ],
      fechaEmision: ['', Validators.required],
      plazo: ['', [
        Validators.required, 
        Validators.pattern(/^[0-9]+$/),
        Validators.min(3)
      ]],
      retiro: ['', Validators.required],
      cliente: ['Externo', Validators.required],
      tasa: [''],
    });

    this.valForm = this._formBuilder.group({
      name: ['', Validators.required],
      mail: ['', [Validators.required, Validators.email]],
      rut: [
        '',
        [
          Validators.required,
          Validators.pattern('^[0-9]{7,10}[-][0-9K]$'),
          this.validateRUT,
        ],
      ],
      telefono: ['', [Validators.required, Validators.pattern(/^[0-9]{9}$/)]],
    });
  }

  randomImage: string = '';
  private images: string[] = [
    '../../assets/images/33.jpg',
    '../../assets/images/3.jpg',
    '../../assets/images/4.jpg',
    '../../assets/images/7.jpg',
    '../../assets/images/9.jpg',
    '../../assets/images/12.jpg',
    '../../assets/images/14.jpg',
    '../../assets/images/17.jpg',
    '../../assets/images/23.jpg',
    '../../assets/images/2.jpg',
    '../../assets/images/15.jpg',
    '../../assets/images/26.jpg',
  ];

  ngOnInit(): void {

    this.setRandomBackground();
    
    let investorId = this.idInversorService.getIdInversor();
    this.getChartInstitucion(investorId);
  }

  setRandomBackground(): void {
    const randomIndex = Math.floor(Math.random() * this.images.length);
    this.randomImage = this.images[randomIndex];
  }

  validateMonto(control: AbstractControl): ValidationErrors | null {
    const value = control.value.replace(/\./g, '');
    if (value === '') {
      return null;
    }
    if (isNaN(value) || +value <= 0) {
      return { invalidMonto: true };
    }
    return null;
  }

  formatRUT(input: any) {
    let rut = input.target.value
      .replace(/\./g, '')
      .replace('-', '')
      .toUpperCase();
    if (rut.length > 1) {
      rut = rut.slice(0, -1) + '-' + rut.slice(-1);
    }
    this.valForm.controls['rut'].setValue(rut);
  }

  validateRUT(control: AbstractControl): ValidationErrors | null {
    const rut = control.value;
    if (!rut || rut.length < 9) {
      return { invalidRUT: true };
    }

    const rutBody = rut.slice(0, -2).replace(/\./g, '');
    const verifier = rut.slice(-1).toUpperCase();

    let sum = 0;
    let multiplier = 2;
    for (let i = rutBody.length - 1; i >= 0; i--) {
      sum += +rutBody.charAt(i) * multiplier;
      multiplier = (multiplier + 1) % 8 || 2;
    }
    const dv = 11 - (sum % 11);
    const calculatedVerifier =
      dv === 11 ? '0' : dv === 10 ? 'K' : dv.toString();

    if (verifier !== calculatedVerifier) {
      return { invalidRUT: true };
    }

    return null;
  }

  capitalizeName() {
    const nameControl = this.valForm.get('name');
    if (nameControl?.value) {
      let capitalized = nameControl.value
        .split(' ')
        .map((word: string) => {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');
      nameControl.setValue(capitalized);
    }
  }

  convertToLowerCase(event: any): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.toLowerCase();
    this.valForm.controls['mail'].setValue(value, { emitEvent: false });
  }

  formatMonto(input: any) {
    const originalValue = input.target.value;
    const num = originalValue.replace(/\./g, '');

    if (!isNaN(num)) {
      let formattedValue = num
        .split('')
        .reverse()
        .join('')
        .replace(/(\d{3})(?=\d)/g, '$1.');
      formattedValue = formattedValue.split('').reverse().join('');
      this.formGroup.controls['monto'].setValue(formattedValue, {
        emitEvent: false,
      });
    } else {
      this.formGroup.controls['monto'].setErrors({ invalidMonto: true });
    }
  }

  async sendForm() {
    this.enviandoBtn = true;
    try {
      const formData = {
        ...this.formGroup.value,
        ...this.valForm.value,
      };

      console.log('formData', formData);

      if (this.formGroup.valid) {
        const response: any = await this.settings.get_query(
          2,
          '/cliente-inversionista/simulation/',
          formData,
          true
        );
        console.log('Formulario enviado correctamente:', response);
        console.log('ID del inversionista2:', response._body.investor_id);

        const investorId = response._body.investor_id;
        this.idInversorService.setIdInversor(investorId);

        this.getChartInstitucion(investorId);

        this.eventService.triggerFormSubmitted();
        this.step = 2;
      } else {
        console.error('El formulario no es válido');
      }
    } catch (error: any) {
      console.error('Error al enviar el formulario:', error);
      this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
        duration: 20000,
        panelClass: 'simpli-snack',
      });
    } finally {
      this.enviandoBtn = false;
    }
  }

  async getChartInstitucion(investorId: any): Promise<void> {
    try {
      if (investorId) {
        const bd: any = await this.settings.get_query(
          1,
          `/cliente-inversionista/chart-institucion/${investorId}/`,
          {},
          true
        );
        const body_data: any = bd._body;
        this.sharedDataService.setChartInstitucionData(body_data);
      } else {
        console.log('ID de inversor no válido.');
      }
    } catch (error) {
      console.error('Error al obtener los datos del chart:', error);
      throw error;
    }
  }

  navigateToLogin() {
    this.router.navigate(['/login']);
  }


  siguiente_paso($ev: any, value: any, step: Number) {
    $ev.preventDefault();
  
    if (step === 1) {
      for (let c in this.valForm.controls) {
        this.valForm.controls[c].markAsTouched();
      }
      if (this.valForm.valid) {
        this.subStep = 2;
      } else {
        console.error('El sub-step 1 no es válido');
        this.snackBar.open(
          'Por favor, corrige los errores antes de continuar.',
          'Aceptar',
          {
            duration: 5000,
            panelClass: 'simpli-snack',
          }
        );
      }
    } else {
      this.enviandoBtn = true;
  
      for (let c in this.formGroup.controls) {
        this.formGroup.controls[c].markAsTouched();
      }
  
      if (this.formGroup.valid) {
        this.sendForm()
          .finally(() => {
            this.enviandoBtn = false;
          });
      } else {
        console.error('El sub-step 2 no es válido');
        this.snackBar.open(
          'Por favor, corrige los errores antes de continuar.',
          'Aceptar',
          {
            duration: 5000,
            panelClass: 'simpli-snack',
          }
        );
        this.enviandoBtn = false;
      }
    }
  }
  

  validateMontoMinimo(control: AbstractControl): ValidationErrors | null {
    const value = control.value.replace(/\./g, '');
    if (value === '') {
      return null;
    }
    if (+value < 500000) {
      return { montoMinimo: true };
    }
    return null;
  }

  onVolver() {
    this.subStep = 1;
    this.enviandoBtn = false;
  }

  @ViewChild(TablaInversionesComponent) tablaInversionesComponent!: TablaInversionesComponent;

  goToPreviousStep() {
    this.step = 1;
    this.subStep = 2;
  
    if (this.tablaInversionesComponent) {
      this.tablaInversionesComponent.resetDataSource();
    }
  
    this.dataSource.forEach(item => {
      item.value = '';
    });
  
    this.dataSource2.forEach(item => {
      item.mensual = ''; 
      item.anual = '';   
    });
  
    this.stepper.previous(); 
  }
  

  dataSource: any[] = [];
  dataSource2: any[] = [];

  async sendPdf() {
    this.enviandoBtn = true;

    try {
      const investorId = this.idInversorService.getIdInversor();
      if (investorId) {
        const response: any = await this.settings.get_query(2, `/cliente-inversionista/simulation-email/${investorId}/`,{}, true);
        const body_data = response._body;

        this.step = 3;
        this.enviandoBtn = false;
 
      } else {
        console.error('ID de inversor no válido.');
      }
    } catch (error) {
      console.error('Error en la solicitud para enviar el PDF:', error);
      this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
        duration: 20000,
        panelClass: 'simpli-snack'
      });
    } finally {
      this.enviandoBtn = false;
    }
  }
}
